import { schoolYears } from '../../utils/schoolYears';
import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext.js';
import LocationSelectorForForm from '../locaties/LocationSelectorForForm.js';

const validYears = schoolYears();

function NewGroup() {
  const { userInfo } = useAuth();
  const userRole = userInfo.role;

  const [groupName, setGroupName] = useState('');
  const [locations, setLocations] = useState([]);
  const [selectedLocation, setSelectedLocation] = useState('');
  const [schoolYear, setSchoolYear] = useState('');
  const [message, setMessage] = useState('');
  const navigate = useNavigate();
  const token = sessionStorage.getItem('jwtToken');

  // Alleen voor super_admin: haal locaties op
  useEffect(() => {
    if (userRole === 'super_admin') {
      axios.get(
        `${process.env.REACT_APP_BACKEND_URL}/location/allLocations`,
        {
          headers: {
            'Authorization': `Bearer ${token}`          }
        }
      )
        .then(res => {
          const locs = res.data.data || res.data;
          setLocations(locs);
        })
        .catch(err => console.error('Error fetching locations', err));
    }
  }, [userRole, token]);

  const handleGroupNameChange = e => setGroupName(e.target.value);
  const handleSchoolYearChange = e => setSchoolYear(e.target.value);

  const handleSaveGroup = () => {
    // Verplicht schooljaar
    if (!schoolYear) {
      setMessage('Kies een schooljaar');
      setTimeout(() => setMessage(''), 3000);
      return;
    }

    const payload = {
      groep_name: groupName,
      status: 'active',
      school_year: schoolYear
    };

    if (userRole === 'super_admin' && selectedLocation) {
  payload.location_id_from_frontend = selectedLocation.trim();
}


    axios.post(
      `${process.env.REACT_APP_BACKEND_URL}/group/add`,
      payload,
      { headers: { 'Authorization': `Bearer ${token}` } }
    )
      .then(() => navigate('/groups'))
      .catch(err => {
        if (
          err.response &&
          err.response.data &&
          err.response.data.error === 'Location ID is required'
        ) {
          setMessage('Kies een locatie');
          setTimeout(() => setMessage(''), 3000);
        } else {
          console.error('Error creating group', err);
        }
      });
  };

  const handleGoBack = () => navigate('/groups');

  return (
    <div className='new-group'>
      {message && <div className='alert alert-info'>{message}</div>}
      <h2>Nieuwe Groep</h2>
      <form onSubmit={e => e.preventDefault()}>
        {/* Groepsnaam */}
        <div className='form-group mb-3'>
          <label>
            Groepsnaam<span style={{ color: 'red' }}>*</span>
          </label>
          <input
            type='text'
            value={groupName}
            onChange={handleGroupNameChange}
            className='form-control'
            required
          />
        </div>

        {/* Schooljaar selectie */}
        <div className='form-group mb-3'>
          <label>
            Schooljaar<span style={{ color: 'red' }}>*</span>
          </label>
          <select
            name='school_year'
            value={schoolYear}
            onChange={handleSchoolYearChange}
            className='form-select'
            required
          >
            <option value=''>-- Kies schooljaar --</option>
            {validYears.map(year => (
              <option key={year} value={year}>
                {year}
              </option>
            ))}
          </select>
        </div>

        {/* Alleen voor super_admin: locatie keuze */}
        <LocationSelectorForForm
          label='Kies Locatie *'
          userRole={userRole}
          value={selectedLocation}
          onChange={e => setSelectedLocation(e.target.value)}
          locations={locations}
        />

        {/* Buttons */}
        <div className='form-group'>
          <button
            type='button'
            onClick={handleSaveGroup}
            className='btn btn-primary'
          >
            Opslaan
          </button>
          <button
            type='button'
            onClick={handleGoBack}
            className='btn btn-secondary ms-2'
          >
            Terug
          </button>
        </div>
      </form>
    </div>
  );
}

export default NewGroup;
